// extracted by mini-css-extract-plugin
export default {"advertListCounter":"c-a_fx"};